// cameraPopupSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
};

const cameraPopupSlice = createSlice({
  name: 'cameraPopup',
  initialState,
  reducers: {
    openCameraPopup: (state) => {
      state.isOpen = true;
    },
    closeCameraPopup: (state) => {
      state.isOpen = false;
    },
    toggleCameraPopup: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { openCameraPopup, closeCameraPopup, toggleCameraPopup } = cameraPopupSlice.actions;

export default cameraPopupSlice.reducer;
